import { render, staticRenderFns } from "./CreatedBy.vue?vue&type=template&id=511cd9a6&scoped=true&"
import script from "./CreatedBy.vue?vue&type=script&lang=js&"
export * from "./CreatedBy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511cd9a6",
  null
  
)

export default component.exports